<svg id="b" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g id="c" data-name="Titles">
    <g>
      <rect width="64" height="64" fill="none"/>
      <g>
        <path class="filled" d="M42.023,21.977c-5.536-5.536-14.511-5.536-20.046,0-5.536,5.536-5.536,14.51,0,20.046,5.536,5.536,14.51,5.536,20.046,0,5.535-5.536,5.535-14.51,0-20.046Zm-3.704,13.514l-2.828,2.828-3.492-3.492-3.492,3.492-2.828-2.828,3.492-3.492-3.492-3.492,2.828-2.828,3.492,3.492,3.492-3.492,2.828,2.828-3.492,3.492,3.492,3.492Z" fill="#e83434"/>
        <polygon class="cutout" points="35.491 25.68 32 29.172 28.508 25.68 25.68 28.508 29.172 32 25.68 35.491 28.508 38.319 32 34.828 35.491 38.319 38.32 35.491 34.828 32 38.32 28.508 35.491 25.68" fill="#fff"/>
      </g>
    </g>
  </g>
</svg>